import * as angular from 'angular';
import { ManageUsersModule } from './manage-users/manage-users.module';

angular.module('nv.features', ['nv.features.not-found', ManageUsersModule]);
